import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { MotionPlugin } from '@vueuse/motion'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// CSS import order matters:
// 1. Element Plus base
import 'element-plus/dist/index.css'
// 2. Our design system (CSS variables)
import './assets/design-system.css'
// 3. Element Plus overrides (rewrites El vars using our tokens)
import './assets/el-override.css'
// 4. Tailwind utilities (no preflight — safe with Element Plus)
import './assets/tailwind.css'
// 5. Inter font
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

// Register all Element Plus icons globally
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(MotionPlugin)

app.mount('#app')
